import { GeneralStyle } from '@website-builder/model/style/general-style';

export class ImageWrapperStyle extends GeneralStyle {
  boxDecoration = '';
  inverseStyle = '';
  boxShadow = '';
  hoverBoxShadow = '';
  cursor = 'pointer';

  static normalize(styles: Partial<ImageWrapperStyle>): ImageWrapperStyle {
    const generalStyle: GeneralStyle = GeneralStyle.normalize(styles);
    const pureStyles = new ImageWrapperStyle();

    Object.assign(pureStyles, generalStyle);

    pureStyles.boxDecoration = styles.boxDecoration ?? pureStyles.boxDecoration;
    pureStyles.inverseStyle = styles.inverseStyle ?? pureStyles.inverseStyle;
    pureStyles.boxShadow = styles.boxShadow ?? pureStyles.boxShadow;
    pureStyles.hoverBoxShadow = styles.hoverBoxShadow ?? pureStyles.hoverBoxShadow;
    pureStyles.cursor = styles.cursor ?? pureStyles.cursor;

    return pureStyles;
  }
}
